import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import SvgIcon from "@mui/material/SvgIcon";
import classnames from "classnames";
import { useStyles } from "./Reactions.styles.js";
const Crying = (t0)=>{
    const $ = c(33);
    const { size: t1, color: t2 } = t0;
    const size = void 0 === t1 ? "default" : t1;
    const color = void 0 === t2 ? "secondary" : t2;
    const { classes } = useStyles();
    const t3 = classes[`icon_size_${size}`];
    const t4 = classes[`icon_color_${color}`];
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = classnames(t3, t4);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M10.0109 17.0678C13.8997 17.0678 17.0521 13.9153 17.0521 10.0266C17.0521 6.13781 13.8997 2.98535 10.0109 2.98535C6.12218 2.98535 2.96973 6.13781 2.96973 10.0266C2.96973 13.9153 6.12218 17.0678 10.0109 17.0678Z",
            fill: "url(#paint0_radial_4706_230331)"
        });
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M10.0109 17.0678C13.8997 17.0678 17.0521 13.9153 17.0521 10.0266C17.0521 6.13781 13.8997 2.98535 10.0109 2.98535C6.12218 2.98535 2.96973 6.13781 2.96973 10.0266C2.96973 13.9153 6.12218 17.0678 10.0109 17.0678Z",
            fill: "url(#paint1_radial_4706_230331)"
        });
        t8 = /*#__PURE__*/ jsx("path", {
            d: "M10.0139 17.0482C13.9026 17.0482 17.0551 13.8958 17.0551 10.007C17.0551 6.11828 13.9026 2.96582 10.0139 2.96582C6.12511 2.96582 2.97266 6.11828 2.97266 10.007C2.97266 13.8958 6.12511 17.0482 10.0139 17.0482Z",
            fill: "url(#paint2_radial_4706_230331)",
            fillOpacity: "0.8"
        });
        t9 = /*#__PURE__*/ jsx("path", {
            d: "M10.0145 2.96642C6.12571 2.96642 2.97325 6.11887 2.97325 10.0076C2.97325 13.8964 6.12571 17.0488 10.0145 17.0488C13.9032 17.0488 17.0557 13.8964 17.0557 10.0076C17.0557 6.11887 13.9032 2.96642 10.0145 2.96642Z",
            fill: "url(#paint3_radial_4706_230331)",
            fillOpacity: "0.8"
        });
        $[3] = t6;
        $[4] = t7;
        $[5] = t8;
        $[6] = t9;
    } else {
        t6 = $[3];
        t7 = $[4];
        t8 = $[5];
        t9 = $[6];
    }
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t19;
    let t20;
    let t21;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ jsx("g", {
            opacity: "0.4",
            filter: "url(#filter0_f_4706_230331)",
            children: /*#__PURE__*/ jsx("path", {
                d: "M13.6292 5.28151C13.6292 6.29237 12.0234 7.11184 10.0426 7.11184C8.06182 7.11184 6.45605 6.29237 6.45605 5.28151C6.45605 4.27064 8.06182 3.45117 10.0426 3.45117C12.0234 3.45117 13.6292 4.27064 13.6292 5.28151Z",
                fill: "url(#paint4_radial_4706_230331)"
            })
        });
        t11 = /*#__PURE__*/ jsx("path", {
            d: "M7.96364 13.8911C7.84727 13.9467 7.77578 13.9809 7.67449 13.9572C7.22989 13.8516 8.06374 12.4004 10.0061 12.4004C11.94 12.4004 12.7822 13.8516 12.3376 13.9572C12.2363 13.9809 12.1649 13.9467 12.0485 13.8911C11.1175 13.2079 8.98268 13.1433 7.96364 13.8911Z",
            fill: "#3F1C30"
        });
        t12 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.10539 14.1277L8.08219 14.1388C8.07634 14.1416 8.0703 14.1445 8.06408 14.1475C7.96132 14.1972 7.80952 14.2706 7.61255 14.2245L7.6121 14.2244L7.61164 14.2243C7.46385 14.1892 7.35257 14.0864 7.307 13.9442C7.26738 13.8206 7.2851 13.6934 7.31657 13.5902C7.38076 13.3796 7.53778 13.1496 7.75703 12.9412C8.20355 12.5169 8.96521 12.127 10.0069 12.127C11.0448 12.127 11.8062 12.5171 12.2534 12.941C12.4731 13.1491 12.6308 13.3789 12.6958 13.5891C12.7277 13.6921 12.746 13.8193 12.7069 13.9432C12.6617 14.086 12.5503 14.1891 12.4022 14.2243L12.4018 14.2244L12.4013 14.2245C12.2044 14.2706 12.0526 14.1972 11.9498 14.1475C11.9436 14.1445 11.9375 14.1416 11.9317 14.1388L11.9085 14.1277L11.8878 14.1125C11.4869 13.8183 10.7857 13.6366 10.0371 13.6289C9.28939 13.6211 8.56875 13.7877 8.12612 14.1125L8.10539 14.1277ZM12.0498 13.8918C11.1186 13.2085 8.98336 13.1438 7.96412 13.8918C7.84772 13.9474 7.77622 13.9816 7.67491 13.9579C7.23022 13.8523 8.06424 12.4008 10.0069 12.4008C11.9413 12.4008 12.7837 13.8523 12.339 13.9579C12.2377 13.9816 12.1662 13.9474 12.0498 13.8918Z",
            fill: "url(#paint5_linear_4706_230331)"
        });
        t13 = /*#__PURE__*/ jsx("path", {
            d: "M8.69417 9.25169C8.69417 9.91061 8.3346 10.4448 7.89103 10.4448C7.44747 10.4448 7.08789 9.91061 7.08789 9.25169C7.08789 8.59276 7.44747 8.05859 7.89103 8.05859C8.3346 8.05859 8.69417 8.59276 8.69417 9.25169Z",
            fill: "#421D30"
        });
        t14 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.65397 10.2267C8.48019 10.4849 8.21497 10.6798 7.89136 10.6798C7.56775 10.6798 7.30254 10.4849 7.12875 10.2267C6.954 9.96712 6.85352 9.62182 6.85352 9.25202C6.85352 8.88222 6.954 8.53691 7.12875 8.27731C7.30254 8.01914 7.56775 7.82422 7.89136 7.82422C8.21497 7.82422 8.48019 8.01914 8.65397 8.27731C8.82873 8.53691 8.92921 8.88222 8.92921 9.25202C8.92921 9.62182 8.82873 9.96712 8.65397 10.2267ZM7.89136 10.4451C8.33493 10.4451 8.69451 9.91095 8.69451 9.25202C8.69451 8.59309 8.33493 8.05893 7.89136 8.05893C7.4478 8.05893 7.08822 8.59309 7.08822 9.25202C7.08822 9.91095 7.4478 10.4451 7.89136 10.4451Z",
            fill: "url(#paint6_linear_4706_230331)"
        });
        t15 = /*#__PURE__*/ jsx("path", {
            d: "M11.3195 9.25169C11.3195 9.91061 11.6791 10.4448 12.1226 10.4448C12.5662 10.4448 12.9258 9.91061 12.9258 9.25169C12.9258 8.59276 12.5662 8.05859 12.1226 8.05859C11.6791 8.05859 11.3195 8.59276 11.3195 9.25169Z",
            fill: "#421D30"
        });
        t16 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.3597 10.2267C11.5335 10.4849 11.7987 10.6798 12.1223 10.6798C12.4459 10.6798 12.7111 10.4849 12.8849 10.2267C13.0597 9.96712 13.1602 9.62182 13.1602 9.25202C13.1602 8.88222 13.0597 8.53691 12.8849 8.27731C12.7111 8.01914 12.4459 7.82422 12.1223 7.82422C11.7987 7.82422 11.5335 8.01914 11.3597 8.27731C11.1849 8.53691 11.0845 8.88222 11.0845 9.25202C11.0845 9.62182 11.1849 9.96712 11.3597 10.2267ZM12.1223 10.4451C11.6787 10.4451 11.3192 9.91095 11.3192 9.25202C11.3192 8.59309 11.6787 8.05893 12.1223 8.05893C12.5659 8.05893 12.9254 8.59309 12.9254 9.25202C12.9254 9.91095 12.5659 10.4451 12.1223 10.4451Z",
            fill: "url(#paint7_linear_4706_230331)"
        });
        t17 = /*#__PURE__*/ jsx("path", {
            d: "M6.81193 6.68537C7.45243 6.31554 7.96872 6.22755 8.30129 6.30485C8.43068 6.3352 8.52438 6.42933 8.54685 6.55258C8.55481 6.59622 8.54959 6.64998 8.53607 6.70334C8.49349 6.87139 8.32043 6.94001 8.15034 6.97347C7.36226 7.12849 6.77661 7.38531 6.12639 7.93585C5.9565 8.07935 5.68318 8.47346 5.56094 8.39179C5.4387 8.31013 5.61762 7.92405 5.78055 7.68099C6.0332 7.30407 6.43419 6.90304 6.81251 6.68459L6.81193 6.68537Z",
            fill: "#5C3147"
        });
        t18 = /*#__PURE__*/ jsx("path", {
            d: "M13.2017 6.68537C12.5612 6.31554 12.045 6.22755 11.7124 6.30485C11.583 6.3352 11.4893 6.42933 11.4668 6.55258C11.4589 6.59622 11.4641 6.64998 11.4776 6.70334C11.5202 6.87139 11.6932 6.94001 11.8633 6.97347C12.6514 7.12849 13.2371 7.38531 13.8873 7.93585C14.0572 8.07935 14.3305 8.47346 14.4527 8.39179C14.575 8.31013 14.396 7.92405 14.2331 7.68099C13.9805 7.30407 13.5795 6.90304 13.2012 6.68459L13.2017 6.68537Z",
            fill: "#5C3147"
        });
        t19 = /*#__PURE__*/ jsx("path", {
            d: "M8.21299 13.618C8.32512 12.7048 7.49447 10.8784 7.1418 10.1538C7.07078 10.0078 6.87641 9.98862 6.77799 10.1177C6.29152 10.7555 5.12246 12.3698 5.00901 13.2938C4.92255 14.1471 5.56981 14.9122 6.45448 15.0012C7.33913 15.0907 8.12653 14.4713 8.21276 13.6177L8.21299 13.618Z",
            fill: "url(#paint8_radial_4706_230331)"
        });
        t20 = /*#__PURE__*/ jsx("path", {
            d: "M8.21299 13.618C8.32512 12.7048 7.49447 10.8784 7.1418 10.1538C7.07078 10.0078 6.87641 9.98862 6.77799 10.1177C6.29152 10.7555 5.12246 12.3698 5.00901 13.2938C4.92255 14.1471 5.56981 14.9122 6.45448 15.0012C7.33913 15.0907 8.12653 14.4713 8.21276 13.6177L8.21299 13.618Z",
            fill: "url(#paint9_radial_4706_230331)",
            fillOpacity: "0.3"
        });
        t21 = /*#__PURE__*/ jsx("path", {
            d: "M7.13231 11.7335C7.36576 11.2108 7.33802 10.6901 7.07034 10.5705C6.80266 10.451 6.3964 10.7778 6.16295 11.3006C5.92949 11.8233 5.95723 12.344 6.22491 12.4635C6.49259 12.5831 6.89885 12.2562 7.13231 11.7335Z",
            fill: "url(#paint10_radial_4706_230331)"
        });
        $[7] = t10;
        $[8] = t11;
        $[9] = t12;
        $[10] = t13;
        $[11] = t14;
        $[12] = t15;
        $[13] = t16;
        $[14] = t17;
        $[15] = t18;
        $[16] = t19;
        $[17] = t20;
        $[18] = t21;
    } else {
        t10 = $[7];
        t11 = $[8];
        t12 = $[9];
        t13 = $[10];
        t14 = $[11];
        t15 = $[12];
        t16 = $[13];
        t17 = $[14];
        t18 = $[15];
        t19 = $[16];
        t20 = $[17];
        t21 = $[18];
    }
    let t22;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = /*#__PURE__*/ jsxs("filter", {
            id: "filter0_f_4706_230331",
            x: "4.68353",
            y: "1.67865",
            width: "10.7179",
            height: "7.20617",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "0.88626",
                    result: "effect1_foregroundBlur_4706_230331"
                })
            ]
        });
        $[19] = t22;
    } else t22 = $[19];
    let t23;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint0_radial_4706_230331",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(9.80442 3.82778) scale(13.1627)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFF1B6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.43",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.7",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF8E00"
                })
            ]
        });
        $[20] = t23;
    } else t23 = $[20];
    let t24;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint1_radial_4706_230331",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(6.82248 4.09272) rotate(54.7041) scale(13.9648 13.9487)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.608798",
                    stopColor: "#FFE437",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.858784",
                    stopColor: "#FF79B1",
                    stopOpacity: "0.45"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.994222",
                    stopColor: "#FF3673",
                    stopOpacity: "0.56"
                })
            ]
        });
        $[21] = t24;
    } else t24 = $[21];
    let t25;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t25 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint2_radial_4706_230331",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.0139 10.3277) rotate(-90) scale(7.74606 7.4002)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.848958",
                    stopColor: "#FFC60C",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF7039",
                    stopOpacity: "0.68"
                })
            ]
        });
        $[22] = t25;
    } else t25 = $[22];
    let t26;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint3_radial_4706_230331",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.0145 9.687) rotate(90) scale(7.36183 7.30015)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.847356",
                    stopColor: "#FE789B",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F11414",
                    stopOpacity: "0.41"
                })
            ]
        });
        $[23] = t26;
    } else t26 = $[23];
    let t27;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t27 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint4_radial_4706_230331",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.0426 5.28151) rotate(89.9999) scale(1.83033 3.36493)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "white"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFED49",
                    stopOpacity: "0"
                })
            ]
        });
        $[24] = t27;
    } else t27 = $[24];
    let t28;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t28 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint5_linear_4706_230331",
            x1: "9.72554",
            y1: "12.4008",
            x2: "9.72554",
            y2: "14.2062",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FD9E28"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.787073",
                    stopColor: "#FFDF8C"
                })
            ]
        });
        $[25] = t28;
    } else t28 = $[25];
    let t29;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t29 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint6_linear_4706_230331",
            x1: "7.89136",
            y1: "7.86835",
            x2: "6.82528",
            y2: "9.74471",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.0345786",
                    stopColor: "#FD9E28"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFE39E"
                })
            ]
        });
        $[26] = t29;
    } else t29 = $[26];
    let t30;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t30 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint7_linear_4706_230331",
            x1: "12.1223",
            y1: "7.86835",
            x2: "13.1884",
            y2: "9.74471",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.0345786",
                    stopColor: "#FD9E28"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFE39E"
                })
            ]
        });
        $[27] = t30;
    } else t30 = $[27];
    let t31;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t31 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint8_radial_4706_230331",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(8.06163 10.8914) rotate(50.4418) scale(4.24312)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#57D7FF"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.578726",
                    stopColor: "#27C1FF"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.906143",
                    stopColor: "#008FD8"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#009AD8"
                })
            ]
        });
        $[28] = t31;
    } else t31 = $[28];
    let t32;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t32 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint9_radial_4706_230331",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(7.01464 10.2374) rotate(97.1772) scale(4.62272 4.12915)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#39D0FF"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.690883",
                    stopColor: "#00B6FF"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#66D1FF"
                })
            ]
        });
        $[29] = t32;
    } else t32 = $[29];
    let t33;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t33 = /*#__PURE__*/ jsxs("defs", {
            children: [
                t22,
                t23,
                t24,
                t25,
                t26,
                t27,
                t28,
                t29,
                t30,
                t31,
                t32,
                /*#__PURE__*/ jsxs("radialGradient", {
                    id: "paint10_radial_4706_230331",
                    cx: "0",
                    cy: "0",
                    r: "1",
                    gradientUnits: "userSpaceOnUse",
                    gradientTransform: "translate(6.54794 11.517) rotate(108.091) scale(1.01313 0.497584)",
                    children: [
                        /*#__PURE__*/ jsx("stop", {
                            stopColor: "#C5F1FF",
                            stopOpacity: "0.6"
                        }),
                        /*#__PURE__*/ jsx("stop", {
                            offset: "1",
                            stopColor: "#33C9FF",
                            stopOpacity: "0"
                        })
                    ]
                })
            ]
        });
        $[30] = t33;
    } else t33 = $[30];
    let t34;
    if ($[31] !== t5) {
        t34 = /*#__PURE__*/ jsxs(SvgIcon, {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: t5,
            children: [
                t6,
                t7,
                t8,
                t9,
                t10,
                t11,
                t12,
                t13,
                t14,
                t15,
                t16,
                t17,
                t18,
                t19,
                t20,
                t21,
                t33
            ]
        });
        $[31] = t5;
        $[32] = t34;
    } else t34 = $[32];
    return t34;
};
export { Crying };
